module.exports = __webpack_public_path__ + "static/bilal-f6125b7cb2ff17bb3fef9750791eee30.jpg";